import * as React from 'react';
import { observer } from 'mobx-react';
import { IInstructorImageProps } from './IInstructorImageProps';

@observer
export class InstructorImage extends React.Component<IInstructorImageProps> {
  render() {
    const InstructorImageExixst = (
      <img className="instructor-image" src={this.props.InstructorImage} alt="instructor" />
    );
    const InstrucotrImageDoesntExist = (
      <img className="instructor-image" src="Images/no-avatar.png" alt="instructor" />
    );

    const InstructorImage =
      this.props.InstructorImage && this.props.InstructorImage !== ''
        ? InstructorImageExixst
        : InstrucotrImageDoesntExist;

    return <div className="instructor-image-wrapper"> {InstructorImage} </div>;
  }
}
